import React from 'react';
import { Routes, Route, useParams } from 'react-router-dom';
import { WeddingPainting } from './pages/WeddingPainting';
import { BirdsPainting } from './pages/BirdsPainting';
import { LovePainting, LoveEditor } from './pages/LovePainting';
import { WeddingProps } from './types/orders/wedding';
import AudioProvider from './hooks/audio/AudioContext';

const WEDDING_CONFIGS: Record<string, WeddingProps> = {
    wedding11052001: {
        date: '2001-05-11',
        targetPath: '/paintings/wedding-2001-05-11/targets/wedding-2001-05-11-target.json',
        picturePath: '/paintings/wedding-2001-05-11/images/picture.webp',
    },
    wedding03091994: {
        date: '1994-09-03',
        targetPath: '/paintings/wedding-1994-09-03/targets/wedding-1994-09-03-target.json',
        picturePath: '/paintings/wedding-1994-09-03/images/picture.webp',
    },
};

const CraftRoute: React.FC = () => {
    const { type, id } = useParams<{ type: string; id: string }>();
    if (!type || !id) return null;

    const config = WEDDING_CONFIGS[id];
    if (!config) return null;

    return <WeddingPainting {...config} />;
};

const PaintingRoute: React.FC = () => {
    const { id } = useParams<{ id: string }>();
    if (!id) return null;

    const seriesType = id.substring(0, 4);
    if (!seriesType) return null;

    switch (seriesType) {
        case 'BRDS':
            return <BirdsPainting id={id} />;
        case 'LVPC':
            return <LovePainting id={id} />;
        default:
            return null;
    }
};

const App: React.FC = () => {
    return (
        <Routes>
            <Route element={<AudioProvider />}>
                <Route path="/craft/:type/:id" element={<CraftRoute />} />
                <Route path="/painting/:id" element={<PaintingRoute />} />
                <Route path="/painting/:id/editor" element={<LoveEditor />} />
            </Route>
        </Routes>
    );
};

export default App;
